module.exports = __webpack_public_path__ + "assets/img/slogan-ef172c02.png";